import matchdaysJson from '../../constants/matchdays.json';

const generateMatrixData = (matches) => {
    const nTeams = matches.length + 1;

    const data = {
        headers: [],
        matrix: []
    }
    if (nTeams >= 2 && nTeams <= 128 && (Math.log2(nTeams) % 1 === 0)) {
        const headers = generateHeaders(nTeams);
        data.headers = headers;

        const rounds = Math.log2(nTeams);

        const nColumns = rounds + 2 * (rounds - 1);
        const nRows = 2 * (nTeams - 1);

        const matrix = fillMatrix(nRows, nColumns);

        let matchIndex = 0;
        for (let i = 0; i < rounds; i++) {
            let column = i * 3;

            const rStart = Math.pow(2, (i + 1)) - 2;
            const step = Math.pow(2, (i + 2));
            let matchRoundIndex = 0;
            for (let row = rStart; row < nRows; row += step) {
                matrix[row][column].className += "p-0";
                matrix[row + 1][column].className += "p-0";
                if (column > 0) {
                    matrix[row][column - 1].className += "  border-bottom border-darkgray";
                    matrix[row + 1][column - 1].className += " border-top border-darkgray";
                }
                if (column < nColumns - 1) {
                    matrix[row][column + 1].className += " border-bottom  border-darkgray";
                    matrix[row + 1][column + 1].className += " border-top  border-darkgray";

                    if (matchRoundIndex % 2 === 0)
                        for (let krow = row + 1; krow <= row + step; krow++) {
                            matrix[krow][column + 1].className += " border-right  border-darkgray";
                        }
                }

                matrix[row][column].match = matches[matchIndex];
                matrix[row + 1][column].match = matches[matchIndex];
                matchIndex++;
                matchRoundIndex++;
            }
        }
        data.matrix = matrix;
    }

    return data;
}

const generateHeaders = (n) => {
    const matchdayList = matchdaysJson.elimination;

    const headers = [];
    while (n > 1) {
        const title = matchdayList["" + n];
        headers.push(title);
        n = n / 2;
    }
    return headers
}

const fillMatrix = (nR, nC) => {
    const matrix = new Array(nR);
    for (let i = 0; i < nR; i++) {
        const list = new Array(nC);
        for (let j = 0; j < nC; j++) {
            list[j] = {
                className: "",
                match: null
            }
        }
        matrix[i] = list;
    }

    return matrix;
}

export { generateMatrixData };